import { Button, Popover, Table } from 'antd'
import { Link } from 'react-router-dom'
import AuthComponent from '../../../components/AuthComponent'
/**
 *
 * @param {Array} list 表格数据
 * @param {String|Number} total 数据总条数
 * @param {Object} page pageIndex:页码 pageSize:页面大小
 * @param {Function} submit 切换页码时的方法
 * @param {Boolean} loading 数据是否加载中
 * @returns
 */
const PaymentTable = ({ list = [], total, page, submit, loading } = {}) => {
  const columns = [
    {
      title: '日期',
      dataIndex: 'date',
      key: 'date',
      align: 'center',
    },
    {
      title: '缴款单金额',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      align: 'center',
      render: (text, record) => {
        if (record.totalItems && record.totalItems.length > 0) {
          const content = record.totalItems.map((item) => (
            <div key={item.payTypeName}>
              {item.payTypeName}：{item.totalAmount}
            </div>
          ))
          return (
            <Popover content={content}>
              <Button type="link">{text}</Button>
            </Popover>
          )
        } else {
          return <Button type="link">{text}</Button>
        }
      },
    },
    {
      title: '已审核交款金额',
      dataIndex: 'verifiedAmount',
      key: 'verifiedAmount',
      align: 'center',
      render: (text, record) => {
        if (record.verifiedItems && record.verifiedItems.length > 0) {
          const content = record.verifiedItems.map((item) => (
            <div key={item.payTypeName}>
              {item.payTypeName}：{item.totalAmount}
            </div>
          ))
          return (
            <Popover content={content}>
              <Button type="link">{text}</Button>
            </Popover>
          )
        } else {
          return <Button type="link">{text}</Button>
        }
      },
    },
    {
      title: '待审核缴款金额',
      dataIndex: 'unverifiedAmount',
      key: 'unverifiedAmount',
      align: 'center',
      render: (text, record) => {
        if (record.unverifiedItems && record.unverifiedItems.length > 0) {
          const content = record.unverifiedItems.map((item) => (
            <div key={item.payTypeName}>
              {item.payTypeName}：{item.totalAmount}
            </div>
          ))
          return (
            <Popover content={content}>
              <Button type="link">{text}</Button>
            </Popover>
          )
        } else {
          return <Button type="link">{text}</Button>
        }
      },
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <AuthComponent authKey="/payin/payin-slip/item/list">
          <Link
            to={{
              pathname: '/payin/payin-slip/item/list',
              state: { createTime: [record.date, record.date] },
            }}
            style={{ color: '#3e9eff' }}
          >
            查看缴款单
          </Link>
        </AuthComponent>
      ),
    },
  ]
  return (
    <Table
      size="middle"
      loading={loading}
      bordered
      columns={columns}
      dataSource={list}
      rowKey="date"
      pagination={{
        showQuickJumper: true,
        showSizeChanger: true,
        pageSize: page.pageSize,
        current: page.pageIndex,
        total,
        showTotal: (total) => `当前条件共检索到 ${total} 条信息`,
        onChange: (pageIndex, pageSize) => submit({ pageIndex, pageSize }),
      }}
    />
  )
}

export default PaymentTable
